import React, {Fragment, useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import {Animated} from "react-animated-css";
import PageHeaderAtm from "../../../../../atomic/PageHeader/PageHeader";
import {PageTitle} from "../../../../../atomic/PageHeader/PageTitle";
import {WEB_FAQ_LIST} from "../../../../../../constants/appUrls.constants";
import {
    clearFaqDetail,
    getFaqDetail,
    getFaqList,
    updateFaq,
    updateFaqClearState
} from "../../../../../../redux/actions/Web/Faq/faqActions";
import {getLanguages} from "../../../../../../redux/actions/languageActions";
import {isDefined} from "../../../../../../utils";
import {history} from "../../../../../../utils/history";
import faqStyles from "./faqStyles";
import useWebId from "./useWebId";
import FaqForm from "./FaqForm";

export default function EditFaq() {
    const {t} = useTranslation();
    const classes = faqStyles();
    const dispatch = useDispatch();
    const location = useLocation();

    const faqGroupId = location.pathname.split('/').pop();
    const {propertyWebId, fetching: webIdFetching} = useWebId();

    const detailData = useSelector(state => state.faqReducers?.detailData);
    const detailFetching = useSelector(state => state.faqReducers?.detailFetching);
    const listData = useSelector(state => state.faqReducers?.listData);
    const updateData = useSelector(state => state.faqReducers?.updateFaq);
    const updateError = useSelector(state => state.faqReducers?.updateFaqError);
    const updateFetching = useSelector(state => state.faqReducers?.updateFaqFetching);

    useEffect(() => {
        dispatch(getLanguages());
        dispatch(updateFaqClearState());

        return () => {
            dispatch(clearFaqDetail());
        };
    }, [dispatch]);

    useEffect(() => {
        if (isDefined(propertyWebId) && isDefined(faqGroupId)) {
            dispatch(getFaqDetail({property_web_id: propertyWebId, faq_group_id: faqGroupId}));
            // Durum (yayin / onizleme) bilgisi detay servisinde donmuyor; listeden okunur.
            dispatch(getFaqList({property_web_id: propertyWebId}));
        }
    }, [dispatch, propertyWebId, faqGroupId]);

    useEffect(() => {
        if (isDefined(updateData?.status) && updateData.status === 200) {
            dispatch(updateFaqClearState());
            history.push(WEB_FAQ_LIST);
        }
    }, [updateData, dispatch]);

    const currentFaq = Array.isArray(listData)
        ? listData.find(item => String(item?.faq_group_id) === String(faqGroupId))
        : null;
    const initialAction = Number(currentFaq?.status) === 2 ? "preview" : "publish";

    const handleSubmit = ({faq, action}) => {
        if (!isDefined(propertyWebId)) return;

        dispatch(updateFaq({
            property_web_id: propertyWebId,
            faq_group_id: faqGroupId,
            action: action,
            faq: faq,
        }));
    };

    return (
        <Fragment>
            <PageTitle title={t('enw-web-faq-edit', 'Soruyu Düzenle')}/>
            <PageHeaderAtm
                backButton={WEB_FAQ_LIST}
                exitText={t('enw-web-faq-title_short', 'SSS')}
                text={t('enw-web-faq-edit', 'Soruyu Düzenle')}
            />
            <Animated animationIn="fadeIn" animationInDuration={600} isVisible={true}>
                <Container maxWidth="xl">
                    <div className="container-width pb-0 mb-24">
                        {
                            (webIdFetching || detailFetching || !isDefined(detailData)) ?
                                <Box className={classes.loadingBox}>
                                    <CircularProgress className={classes.spinner} style={{color: '#d71f26'}}/>
                                </Box>
                                :
                                <FaqForm
                                    initialLanguages={detailData?.languages}
                                    initialAction={initialAction}
                                    saving={updateFetching}
                                    errorMessage={updateError?.response?.data?.message}
                                    onSubmit={handleSubmit}
                                />
                        }
                    </div>
                </Container>
            </Animated>
        </Fragment>
    );
}
